import getConfig from 'next/config';

const {
  publicRuntimeConfig: { nativeAppDynamicLink },
} = getConfig();

// took from https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system
export const openNativeAppDynamicLink = (): undefined => {
  const userAgent =
    navigator &&
    (navigator.userAgent || navigator.vendor || (window as any).opera);

  if (
    /android/i.test(userAgent) ||
    (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream)
  ) {
    window.open(nativeAppDynamicLink, '_self');
  }

  return;
};
